/* eslint-disable no-unused-vars */
import React from 'react'
import { Content, Radio, Option, Icon, Text, Alert, Row, ButtonContent, Picture, Container } from './styled'
import { Alert as AlertBase } from '@material-ui/lab'
import { string, func, object, bool } from 'prop-types'
import { CreditCard, LocalAtm, AccountBalance, AttachMoney } from '@material-ui/icons'
import { Grid, Box, Typography, Button, useMediaQuery } from '@material-ui/core'
import paypal from '../../../../../assets/paypal2.png'
import oxxo from '../../../../../assets/oxxo.png'
import spei from '../../../../../assets/spei.png'

const Shipping = props => {
  const onOptionClick = value => event => {
    console.log(value)
    props.onChange({ target: { name: 'methodPay', value } })
    props.onFocus({ target: { name: 'methodPay', value } })
  }

  const isMobile = useMediaQuery('(max-width:600px)')

  return (
    <Container>
      {props.errorMessage && (
        <Alert as={AlertBase} severity='error'>{props.errorMessage}</Alert>
      )}
      <Box>
        <Row container as={Grid} spacing={2}>
          <Grid item xs={12} sm={3}>
            <Typography color='secondary' variant='subtitle1' align={isMobile ? 'left' : 'right'}>Nombre:</Typography>
          </Grid>
          <Grid item xs={12} sm={9}>
            <Typography color='primary' variant='subtitle1' align='left'>{`${props.state.name} ${props.state.lastname}`}</Typography>
          </Grid>
        </Row>
        <Row container as={Grid} spacing={2}>
          <Grid item xs={12} sm={3}>
            <Typography color='secondary' variant='subtitle1' align={isMobile ? 'left' : 'right'}>Email:</Typography>
          </Grid>
          <Grid item xs={12} sm={9}>
            <Typography color='primary' variant='subtitle1' align='left'>{props.state.email}</Typography>
          </Grid>
        </Row>
        <Row container as={Grid} spacing={2}>
          <Grid item xs={12} sm={3}>
            <Typography color='secondary' variant='subtitle1' align={isMobile ? 'left' : 'right'}>Fecha de Nacimiento:</Typography>
          </Grid>
          <Grid item xs={12} sm={9}>
            <Typography color='primary' variant='subtitle1' align='left'>{props.state.date}</Typography>
          </Grid>
        </Row>
        {props.doAdressAexist && (
          <Row container as={Grid} spacing={2}>
            <Grid item xs={12} sm={3}>
              <Typography color='secondary' variant='subtitle1' align={isMobile ? 'left' : 'right'}>Dirección</Typography>
            </Grid>
            <Grid item xs={12} sm={9}>
              <Typography color='primary' variant='subtitle1' align='left'>{`${props.state.street_number}, ${props.state.suburb}, ${props.state.postal_code}, ${props.state.city}, ${props.state.state}`}</Typography>
            </Grid>
          </Row>
        )}
        <Grid container justify='flex-end'>
          <Button onClick={event => props.goToStep(0)} style={{ color: 'gray', textTransform: 'none' }}>Cambiar</Button>
        </Grid>
      </Box>

      <Content value={props.state.methodPay || ''}>
        <Option onClick={onOptionClick('paypal')}>
          <Radio value='paypal' />
          <Picture src={paypal} />
        </Option>
        <Option onClick={onOptionClick('cash')}>
          <Radio value='cash' />
          {!isMobile && (
            <Typography color='secondary' variant='subtitle1'>Generar orden de pago</Typography>
          )}
          <Picture style={{ marginLeft: '10px' }} src={oxxo} />
          <Picture style={{ marginLeft: '10px' }} src={spei} />
        </Option>
      </Content>
    </Container>
  )
}

Shipping.propTypes = {
  errorMessage: string,
  onChange: func,
  state: object,
  onFocus: func,
  goToStep: func,
  doAdressAexist: bool
}

export default Shipping
